import React, { useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import BackGroundImageLogin from "../../assets/img/home.png";
import BackGroundLogoLogin from "../../assets/logo/Marca_TAS_Chile.png";

import LoginForm from "./LoginForm";
import ForgotPassword from "./ForgotPassword";

import useMediaQuery from "../../hooks/useMediaQuery";
import { version } from "../../../package.json";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    backgroundColor:"#fff",
    
  },

    container:{
      display:"flex",
      justifyContent:"center",
      alignItems:"center"
    },

  image: {
    backgroundImage: `url(${BackGroundImageLogin})`,
    backgroundRepeat: "no-repeat",
    backgroundSize:'contain',
    borderRadius:'43px',
    filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
    marginTop:'100px',
    marginBottom:'100px',
    
  },
  logo: {
    width: "270px",
    height: "133px",
    backgroundImage: `url(${BackGroundLogoLogin})`,
    backgroundRepeat: "no-repeat",
    backgroundColor: theme.palette.type === "light",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(16, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      opacity: 0.8,
      borderRadius: "10px",
      backgroundColor: "white",
    },
  },
  form: {
    //width: "60%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  contentSubmit: {
    margin: theme.spacing(3, 0, 2),
    textAlign: "center",
  },
  submit: {
    backgroundColor: "#12b1ee",
    fontSize: "14px",
  },
  contentForgotPassword: {
    textAlign: "right",
    marginBottom: "10px",
    margin:"0 40% 0 0",
     maxWidth: "460px"
  },
  forgotPassword: {
    fontFamily: 'Poppins',
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "22px",
    fontSize: "14px",
    color: "#009EF7",
    textAlign: "right"
  },
  title:{
    fontFamily:'Poppins',
    fontWeight:'500',
    fontSize:'32px'
  },
  subtitle:{
    /* poppins regular14 */
    fontFamily:'Poppins',
    fontStyle: 'normal',
    fontWeight:'400',
    fontSize:'14px', 
    lineHeight: '22px',
    opacity:'40%'
  }
  

}));

const Login = () => {
  const [forgot, setForgot] = useState(false);
  const classes = useStyles();

  const showFogotPassword = () => {
    setForgot((prev) => !prev);
  };

  const isMobile = useMediaQuery("max-width", 600);

  return (
    <Grid container component="main" className={classes.root}>

      
        <Grid
        item
        xs={12}
        sm={6}
        md={6}
        component={Paper}
        elevation={0}
        className={isMobile && classes.image}
        square
        >
          <div className={classes.container}>
          <div className={classes.paper}>
          <div className={classes.logo}></div>

          <div className={classes.title}>Bienvenido</div>
          <div className={classes.subtitle}>Ingresa a tu cuenta</div>
          {!forgot ? (
            <LoginForm classes={classes} />
          ) : (
            <ForgotPassword classes={classes} />
          )}

          <Grid container className={classes.contentForgotPassword}>
            <Grid item xs>
              <Link href="#" variant="body2" onClick={showFogotPassword}>
                <span className={classes.forgotPassword}>
                  {!forgot ? "Olvidaste tu contraseña?" : "Volver"}
                </span>
              </Link>
            </Grid>
          </Grid>
          
          </div></div>
        </Grid>
        
        {!isMobile && (
        <Grid item xs={false} sm={4} md={5} className={classes.image} />
        )}
      
    </Grid>
       
        
      
  );
};

export default Login;
